'use no memo';

// useTableRows に hook 関数を直接渡すと React Compiler と非互換
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import ImportCsv from '@/features/import-csv';
import { ImportCsvSearchSchema } from '@/features/import-csv/zod-schemas';
import { defaultNS, useTranslation } from '@/lib/i18n';
import useBusinessPartnerCorporationTableRows from './-hooks/useBusinessPartnerCorporationTableRows';
const BusinessPartnerCorporationImportCsv = () => {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.businessPartner.importCsv.businessPartnerType'
  });
  const {
    t: tCompleteDialog
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.businessPartner.importCsv.completeDialog'
  });
  return <ImportCsv baseLink="/business-partner/import-csv/corporation" baseTitle={t('title.corporation')} exportApiUrl="/v2/business-partner-csv/corporation" exportFilename={t('filename.corporation')} downloadOptions={[{
    mode: 'edit-template',
    label: t('prepareCsvFile.templateTitle.corporation')
  }, {
    mode: 'edit',
    label: t('prepareCsvFile.updateExisting.corporation')
  }]} completeLinkButton={tCompleteDialog('button')} completeLinkUrl="/business-partner" unit={t('unit.corporations')} search={search} navigate={navigate} useTableRows={useBusinessPartnerCorporationTableRows} />;
};
export const Route = createFileRoute('/_staff/business-partner/import-csv/corporation')({
  validateSearch: zodValidator(ImportCsvSearchSchema),
  component: BusinessPartnerCorporationImportCsv
});